import { z } from 'zod';

/**
 * Configuration runtime : un seul build → N environnements.
 * Le fichier /configs/configuration.json est réécrit par la pipeline
 * (placeholders TO_REPLACE substitués par les variable groups Azure DevOps).
 */
const notAPlaceholder = (v: string) => v !== 'TO_REPLACE';

const configurationSchema = z.object({
  clickAndForgetApi: z.object({
    baseUrl: z
      .string()
      .min(1)
      .refine(notAPlaceholder, 'clickAndForgetApi.baseUrl n\'a pas été substitué par la pipeline'),
  }),
  msalConfig: z.object({
    clientId: z
      .string()
      .min(1)
      .refine(notAPlaceholder, 'msalConfig.clientId n\'a pas été substitué par la pipeline'),
    authority: z
      .string()
      .min(1)
      .refine(notAPlaceholder, 'msalConfig.authority n\'a pas été substitué par la pipeline'),
  }),
  logoUrl: z.string().min(1),
});

export type Configuration = z.infer<typeof configurationSchema>;

let configuration: Configuration | undefined;

export async function loadConfiguration(): Promise<Configuration> {
  const url = import.meta.env.DEV
    ? '/configs/configuration.local.json'
    : '/configs/configuration.json';

  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Impossible de charger la configuration (${url}) : HTTP ${response.status}`);
  }

  configuration = configurationSchema.parse(await response.json());
  return configuration;
}

export function getConfiguration(): Configuration {
  if (!configuration) {
    throw new Error('Configuration non chargée : appeler loadConfiguration() avant tout accès.');
  }
  return configuration;
}
